import React from "react";
//import "materialize-css/dist/css/materialize.min.css";
import project1 from "../images/project1.png";
import project2 from "../images/project2.png";
import project3 from "../images/project3.png";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  CardActions,
  CardMedia,
  Button,
  Typography,
} from "@material-ui/core";
//import M from "materialize-css";
import Navbar from "./Navbar";

const useStyles = makeStyles({
  cardContainer: {
    maxWidth: 345,
    margin: "3rem 1rem auto",
  },
});

const Projects = () => {
  const classes = useStyles();
  return (
    <Box component="div">
      <Navbar name={"PROJECTS"} />
      <Typography
        variant="h4"
        style={{ textAlign: "center", color: "white", marginTop: "4.5rem" }}
      >
        PROJECTS
      </Typography>
      <Grid container justify="center" spacing={3}>
        <Grid item xs={12} sm={8} md={3}>
          <Card className={classes.cardContainer}>
            <CardActionArea>
              <CardMedia
                component="img"
                alt="Project 1"
                height={150}
                image={project1}
              ></CardMedia>
              <CardContent>
                <Typography varient="h5">
                  Web Application - September 2020
                </Typography>
                <Typography varient="body2" color="textSecondary" component="p">
                  The Application stores user credits so that one user can
                  transfer their credits to another user. The app also stores
                  the transaction logs. The project aimed to learn the MERN
                  technology and imply back transaction functionality.
                </Typography>
                <Typography varient="h5">
                  Tech Stack: MERN, Reactstrap. Bootstrap, deployed on Heroku
                  using Git.
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="small" color="primary">
                  Code
                </Button>
                <Button size="small" color="primary">
                  Live Demo
                </Button>
              </CardActions>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} sm={8} md={3}>
          <Card className={classes.cardContainer}>
            <CardActionArea>
              <CardMedia
                component="img"
                alt="Project 2"
                height={150}
                image={project2}
              ></CardMedia>
              <CardContent>
                <Typography varient="h5">
                  Web Application - June 2020
                </Typography>
                <Typography varient="body2" color="textSecondary" component="p">
                  To make blogging more interesting and personalized, I proposed
                  “Share Your Story–Blog Site” where anyone with the valid email
                  ID can create their account and can blog with full
                  authentication.
                </Typography>
                <Typography varient="h5">
                  Tech Stack: MERN, JWT, Redux, Material-UI, Reactstrap.
                  Bootstrap, deployed on Heroku using Git.
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="small" color="primary">
                  Code
                </Button>
                <Button size="small" color="primary">
                  Live Demo
                </Button>
              </CardActions>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} sm={8} md={3}>
          <Card className={classes.cardContainer}>
            <CardActionArea>
              <CardMedia
                component="img"
                alt="Project 3"
                height={150}
                image={project3}
              ></CardMedia>
              <CardContent>
                <Typography varient="h5">Chatbot - January 2020</Typography>
                <Typography varient="body2" color="textSecondary" component="p">
                  Developed a Chat Bot for Police Bureau of R&D, Delhi under
                  Smart India Hackathon 2020. User can submit their problem as
                  directed by the Bot and after asking all the information it
                  registered the crime.
                </Typography>
                <Typography varient="h5">
                  Tech Stack: React, Node, DialogFlow, MongoDB
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="small" color="primary">
                  Code
                </Button>
                <Button size="small" color="primary">
                  Live Demo
                </Button>
              </CardActions>
            </CardActionArea>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Projects;
